import CompanyAssignmentTab from "./company-assignment-settings";


export default CompanyAssignmentTab;